// allDataService.js
// Service for loading all essential application data before the UI is shown.
// The service coordinates calls across the individual Pinia stores and exposes
// a global reactive flag for "all metadata loaded".

import { ref } from 'vue'
import { useCommunitiesStore } from '@/stores/communitiesStore'
import { useCommunityCompaniesStore } from '@/stores/communityCompaniesStore'
import { useMeteringPointMembershipsStore } from '@/stores/meteringPointMembershipsStore'
import { useApplicantStore } from '@/stores/applicationStore'
import { useSnackbarStore } from '@es-bill/es-bill-common-components'
import i18n from '@/plugins/i18n'

// This function should be awaited before the UI is shown (e.g. during the
// splash-screen phase) and can also be reused later whenever a full reload of
// metadata is required.
export const allMetaDataLoaded = ref(false)

export async function fetchAllData() {
  const communitiesStore = useCommunitiesStore()
  const companiesStore = useCommunityCompaniesStore()
  const meteringPointMembershipsStore = useMeteringPointMembershipsStore()
  const applicantStore = useApplicantStore()
  const snackbarStore = useSnackbarStore()

  // Reset loaded flag so dependants know we are reloading.
  allMetaDataLoaded.value = false

  try {
    // Fetch everything in parallel.
    await Promise.all([
      communitiesStore.fetchCommunities(),
      companiesStore.fetchCommunityCompanies(),
      meteringPointMembershipsStore.fetchMeteringPointMemberships(),
      applicantStore.fetchApplications(),
    ])

    allMetaDataLoaded.value = true
  } catch (error) {
    snackbarStore.showSnackbar(
      i18n.global.t('connectionProblem'),
      '',
      'Warning',
      10000,
      []
    )

    // Retry after a delay...
    setTimeout(() => {
      location.reload()
    }, 10 * 1000)
  }
}


